import React, { createContext, useReducer, useEffect } from "react";

// Router
import Router from "./router";
import Login from "./pages/login";

// Provider
import { Provider } from "react-redux";

// Store
import store from "./store";

import "./App.less";


import { withTranslation  } from 'react-i18next'

export const AuthContext = createContext();

const initialState = {
  isAuthenticated: false,
  user: null
};

const reducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      localStorage.setItem("user", JSON.stringify(action.payload.user));
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user
      };
    case "LOGOUT":
      localStorage.clear();
      return {
        ...state,
        isAuthenticated: false,
        user: null
      };
    default:
      return state;
  }
};

function App() {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    //Para el efecto dl horno
    localStorage.removeItem('furnaceTemp');

    const user = JSON.parse(localStorage.getItem("user") || null);

    if (user) {
      dispatch({
        type: "LOGIN",
        payload: { user }
      });
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        state,
        dispatch
      }}
    >
      <Provider store={store}>
        <div className="App">{!state.isAuthenticated ? <Login /> : <Router />}</div>
      </Provider>
    </AuthContext.Provider>
  );
}

export default withTranslation()(App);
